import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { EventGuestModel } from '@app/events/shared/event-guest.model';

@Component({
  selector: 'app-guest-flags-column',
  standalone: true,
  imports: [NgClass],
  templateUrl: './guest-flags-column.component.html',
})
export class GuestFlagsColumnComponent {
  @Input('item') protected item!: EventGuestModel;

  protected readonly flags = [
    {
      key: 'airborne_allergy',
      label: 'Airborne',
      classes: 'bg-amber-50 text-amber-700',
    },
    {
      key: 'religious_or_lifestyle',
      label: 'Religious',
      classes: 'bg-emerald-50 text-emerald-700',
    },
  ] as const;

  protected isVisible(key: typeof this.flags[number]['key']): boolean {
    return !!this.item.dietary?.[key];
  }
}
